'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = require('./AppBar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-beta/AppBar/index.js
// module id = 1024
// module chunks = 0